import { api } from './client';

export interface EnumOption {
    value: string;
    label: string;
}

interface EnumsResponse {
    status: string;
    data: {
        taskPriorities: EnumOption[];
        externalAssetImportTypes: EnumOption[];
    };
}

export const enumService = {
    getAll: async (): Promise<EnumsResponse['data']> => {
        const response = await api.get<EnumsResponse>('/enums');
        return response.data.data;
    },
};
